import React from "react";
import { cn } from "@/lib/utils";

/**
 * StratoButton — design-system button.
 * variant: "primary" | "secondary" | "ghost"
 * All CTAs in this phase are visual only.
 */
const base =
  "inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium select-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--strato-focus-ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:opacity-50 disabled:pointer-events-none transition-colors duration-150";

const variants = {
  primary:
    "rounded-xl px-5 py-3 text-sm bg-strato-blue text-white hover:bg-strato-blue-hover active:bg-strato-blue-active active:translate-y-[1px]",
  secondary:
    "rounded-xl px-5 py-3 text-sm bg-transparent border border-[color:rgba(28,31,36,0.18)] text-strato-graphite hover:bg-[color:rgba(28,31,36,0.04)] active:bg-[color:rgba(28,31,36,0.06)] dark:border-[color:rgba(255,255,255,0.18)] dark:text-white dark:hover:bg-[color:rgba(255,255,255,0.06)]",
  ghost:
    "rounded-lg px-3 py-2 text-sm bg-transparent text-strato-blue hover:bg-[var(--strato-blue-soft)]",
};

export const StratoButton = React.forwardRef(
  ({ variant = "primary", className, as: Comp = "button", children, ...props }, ref) => {
    return (
      <Comp
        ref={ref}
        className={cn(base, variants[variant], className)}
        {...props}
      >
        {children}
      </Comp>
    );
  },
);
StratoButton.displayName = "StratoButton";
